export default "__VITE_ASSET__DDYaqRgw__"